module.exports = __webpack_public_path__ + "img/financial-light.40c08cc3.svg";